import styled from "styled-components";

export default styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  button {
    cursor: pointer;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border: 0;
    background: transparent;
    color: rgba(109, 125, 151, 1);
    gap: 4px;
    span {
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      display: flex;
      align-items: center;

    }
    img {
      user-select: none;
    }
    @media screen and (max-width: 1200px) {
      span {
        font-size: 10px;
        text-align: end;
      }
      img {
        width: 12px !important;
        height: 100% !important;
      }
    }
  }
`;
